import { render, staticRenderFns } from "./BillReceivebleArchiveList.vue?vue&type=template&id=4ffb4a87"
import script from "./BillReceivebleArchiveList.vue?vue&type=script&lang=js"
export * from "./BillReceivebleArchiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports